import { render, staticRenderFns } from "./DivergentTableLineMobile.vue?vue&type=template&id=5965f139&scoped=true"
import script from "./DivergentTableLineMobile.vue?vue&type=script&lang=js"
export * from "./DivergentTableLineMobile.vue?vue&type=script&lang=js"
import style0 from "./DivergentTableLineMobile.vue?vue&type=style&index=0&id=5965f139&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5965f139",
  null
  
)

export default component.exports